import apiClient from './client';
import type { NavDetailResponse, NavEntriesResponse, NavRequestFilters } from '@/types/navigation-report';

/**
 * API de Relatórios > Navegação (ms-api-system /reports/navigation/entry-flow).
 * `project_id` vai como "4,11"; `domains` vira `domains[]=a&domains[]=b`
 * (serialização padrão do axios, alias que o backend espera).
 */
const baseParams = (filters: NavRequestFilters): Record<string, any> => {
    const params: Record<string, any> = { start: filters.start, end: filters.end };
    if (filters.project_ids?.length) params.project_id = filters.project_ids.join(',');
    if (filters.domains?.length) params.domains = filters.domains;
    if (filters.limit) params.limit = filters.limit;
    return params;
};

/** Lista das páginas de entrada (P1) do recorte. */
export const getNavigationEntries = async (filters: NavRequestFilters): Promise<NavEntriesResponse> => {
    const response = await apiClient.get<NavEntriesResponse>('/reports/navigation/entry-flow', {
        params: baseParams(filters),
    });
    return response.data;
};

/** Detalhe de uma P1: próximas páginas (P2), UTMs de entrada e horários. */
export const getNavigationEntryDetail = async (
    entryPath: string,
    filters: NavRequestFilters
): Promise<NavDetailResponse> => {
    const response = await apiClient.get<NavDetailResponse>('/reports/navigation/entry-flow', {
        params: { ...baseParams(filters), entry_path: entryPath },
    });
    return response.data;
};
